<template>
  <div id="nav-back-content"
    @click="$router.go(-1)">
    <v-icon
      >
      mdi-arrow-left
    </v-icon>
    <span>{{$t('navBack.text')}}</span>
  </div>
</template>

<script>
export default {
  name: "NavBack"
}
</script>
